<script>
  export default {
    name: 'VcStyle',
    render (createElement) {
      return createElement('style', this.$slots.default)
    }
  }
</script>



// WEBPACK FOOTER //
// vc-style.vue?8301bfae